import { ref, Ref } from 'vue'
import { useCoreStore } from '@/shared/store'
import { EmailDomain } from '@/shared/types/other.types'

export const useEmailDomains = () => {
  const coreStore = useCoreStore()

  const emailDomains: Ref<EmailDomain[]> = ref([])
  const filtredEmailDomains: Ref<EmailDomain[]> = ref([])
  const emailDomainsLoading: Ref<boolean> = ref(false)

  const loadEmailDomains = async (): Promise<void> => {
    emailDomainsLoading.value = true
    emailDomains.value = await coreStore.getEmailDomains()
    emailDomainsLoading.value = false
  }

  const onInputEmail = (value: string | number | null): void => {
    if (!emailDomains.value.length) return
    const domainPart = value?.toString().split('@')?.[1] || ''
    if (!domainPart.length) {
      filtredEmailDomains.value = emailDomains.value.filter((domain) => domain.level === 2)
      return
    }
    filtredEmailDomains.value = emailDomains.value
  }

  return {
    emailDomains,
    filtredEmailDomains,
    emailDomainsLoading,
    loadEmailDomains,
    onInputEmail,
  }
}
